import { render, staticRenderFns } from "./foreign-construction.vue?vue&type=template&id=b533369a&scoped=true&"
import script from "./foreign-construction.vue?vue&type=script&lang=js&"
export * from "./foreign-construction.vue?vue&type=script&lang=js&"
import style0 from "./foreign-construction.vue?vue&type=style&index=0&id=b533369a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b533369a",
  null
  
)

export default component.exports